export default __webpack_public_path__ + "static/media/Key_Takeaways_EDIT_Mode.2cd0aa83.png";